import { Image } from '@packages/shared';
import type { FC } from 'react';

export type CriteoBeaconImageProps = {
  /* image src */
  src: string;
};

/**
 * CriteoBeaconImage component to render criteo beacon images
 * */
export const CriteoBeaconImage: FC<CriteoBeaconImageProps> = ({ src }) => (
  <Image src={src} width={1} height={1} alt="" style={{ position: 'absolute' }} unoptimized />
);
